<template>
  <v-avatar v-if="user">
    <img :src="url" :alt="user.name">
  </v-avatar>
</template>

<script>
import { loginService } from '@/services/login';

export default {
  name: "user",
  data() {
    return {
      user: {},
      url: ""
    }
  },
  created() {
    loginService.resolveUser()
      .then(e => {
        this.user = e.data;
        this.url = "/api/resolve-avatar";
      })
      .catch(err => console.log("e: ", JSON.stringify(err)));
  }
};
</script>

<style scoped>

</style>